"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _main = _interopRequireDefault(require("../templates/main"));

var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;

if (!nativeInputValueSetter) {
  nativeInputValueSetter = function nativeInputValueSetter(value) {
    this.value = value;
  };
}

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Main);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Main)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focus: false,
      hover: false,
      height: null
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFocus", function (event) {
      _this.setState({
        focus: true
      }).then(function () {
        if (typeof _this.props.onFocus === 'function') {
          _this.props.onFocus(event);
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleBlur", function (event) {
      _this.setState({
        focus: false
      }).then(function () {
        if (typeof _this.props.onBlur === 'function') {
          _this.props.onBlur(event);
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_nativeElementRef", function (el) {
      if (typeof _this.props.elementRef === 'function') {
        _this.props.elementRef(el);
      }

      _this.nativeElement = el;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_shadowRef", function (el) {
      return _this.shadow = el;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleHover", function () {
      return _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleRootBlur", function () {
      return _this.setState({
        hover: false
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, prevContext) {
      if (prevProps.value !== this.props.value) {
        this.syncHeight();
      }
    }
    /**
     * обработчик фокуса
     * @param {object} event
     * @private
     */

  }, {
    key: "syncHeight",
    value: function syncHeight() {
      var height = this.shadow.scrollHeight,
          maxHeight,
          newHeight;

      if (this.props.rows > 1 && this.lineHeight) {
        height = this.props.rows * this.lineHeight;
      }

      if (this.props.rowsMax && this.lineHeight) {
        maxHeight = Number(this.props.rowsMax) * this.lineHeight;
      }

      newHeight = maxHeight ? Math.min(height, maxHeight) : height;

      if (this.state.height !== newHeight) {
        this.setState({
          height: newHeight
        });
      }

      return this;
    }
  }, {
    key: "_stringify",
    value: function _stringify() {
      if (this.props.value === null || this.props.value === undefined) {
        return '';
      } else {
        return this.props.value;
      }
    }
  }, {
    key: "value",
    get: function get() {
      return this.props.value;
    },
    set: function set(value) {
      nativeInputValueSetter.call(this.nativeElement, value || '');
      this.nativeElement.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  label: '',
  placeholder: '',
  onBlur: null,
  onFocus: null,
  floating: true,
  rows: 1,
  cropLabel: false
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  label: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,

  /**
   * floating label
   */
  floating: _propTypes["default"].bool,
  rows: _propTypes["default"].number,
  cropLabel: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.tFilled
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     * @default 0
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter + 'px'
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter + 'px'
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default left
     */
    textAlign: _propTypes["default"].string,

    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default baseline
     */
    verticalAlign: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default ${palette.gutter * 20}px
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tLabel
     */
    labelColor: _propTypes["default"].string,

    /**
     * @default palette.tsXSmall
     */
    labelFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXSmall
     */
    labelLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    labelPaddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    labelPaddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default visible
     */
    labelOverflow: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    idleColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    idlePlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    idleLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    idleBorderColor: _propTypes["default"].string,

    /**
     * @description none none solid
     */
    idleBorderStyle: _propTypes["default"].string,

    /**
     * @default 1px
     */
    idleBorderWidth: _propTypes["default"].string,

    /**
     * @default scale(0)
     */
    idleBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    idleBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    idleBackground: _propTypes["default"].string,

    /**
     * @default palette.tActive
     */
    focusColor: _propTypes["default"].string,

    /**
     * @default palette.tPlaceholder
     */
    focusPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    focusLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    focusBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    focusBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    focusBorderWidth: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    focusBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    focusBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    focusBackground: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    hoverColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    hoverPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    hoverLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elSecondary
     */
    hoverBorderColor: _propTypes["default"].string,

    /**
     * @default nonr nonr solid
     */
    hoverBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    hoverBorderWidth: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    hoverBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    hoverBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    hoverBackground: _propTypes["default"].string,

    /**
     * @default palette.tDisabled
     */
    disabledColor: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    disabledLabelColor: _propTypes["default"].string,

    /**
     * @default palette.tPlaceholder
     */
    disabledPlaceholder: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    disabledBorderTransform: _propTypes["default"].string,

    /**
     * @default none none dotted
     */
    disabledBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    disabledBorderWidth: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    disabledBorderColor: _propTypes["default"].string,

    /**
     * @default 0
     */
    disabledBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    disabledBackground: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    errorColor: _propTypes["default"].string,

    /**
     * @default palette.tError
     */
    errorLabelColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    errorPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.elError
     */
    errorBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    errorBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    errorBorderWidth: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    errorBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    errorBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    errorBackground: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'TextArea');
var _default = Main;
exports["default"] = _default;